var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.title)?_c('div',{staticClass:"title-wrap"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.data.title)+" ")]),_c('div',{staticClass:"title-period"},[_vm._v(" "+_vm._s(_vm.data.period)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }